import Enum from "./Enum";

export default Enum.create( {
	LEFT: "LEFT",
	RIGHT: "RIGHT",
} );
